export default "__VITE_ASSET__N47yxlb9__"